const LINK_PATTERN =
  /(https?:\/\/[^\s<]+|www\.[^\s<]+|[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;

const createHref = (value: string) => {
  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  if (value.includes('@')) {
    return `mailto:${value}`;
  }

  return `https://${value}`;
};

const setLinkAttributes = (link: HTMLAnchorElement) => {
  const href = link.getAttribute('href') ?? '';

  if (!href || href.startsWith('mailto:')) {
    return;
  }

  link.target = '_blank';
  link.rel = 'noopener noreferrer';
};

const addClassNameToRichText = (className: string, text: string) => {
  const parser = new DOMParser();
  const parsedHtml = parser.parseFromString(text, 'text/html');
  const links = parsedHtml.querySelectorAll<HTMLAnchorElement>('a[href]');

  links.forEach((link) => {
    setLinkAttributes(link);
  });

  // Add class to all <p> tags
  const elements = parsedHtml.querySelectorAll('p');
  elements.forEach((el) => {
    el.classList.add(className);
  });

  const walker = parsedHtml.createTreeWalker(
    parsedHtml.body,
    NodeFilter.SHOW_TEXT,
  );
  const textNodes: Text[] = [];

  let currentNode = walker.nextNode();
  while (currentNode) {
    textNodes.push(currentNode as Text);
    currentNode = walker.nextNode();
  }

  textNodes.forEach((textNode) => {
    const parentElement = textNode.parentElement;
    const nodeValue = textNode.nodeValue ?? '';

    if (
      !parentElement ||
      parentElement.closest('a') ||
      !LINK_PATTERN.test(nodeValue)
    ) {
      LINK_PATTERN.lastIndex = 0;
      return;
    }

    LINK_PATTERN.lastIndex = 0;
    const fragment = parsedHtml.createDocumentFragment();
    let lastIndex = 0;

    nodeValue.replace(LINK_PATTERN, (match, _value, offset: number) => {
      if (offset > lastIndex) {
        fragment.appendChild(
          parsedHtml.createTextNode(nodeValue.slice(lastIndex, offset)),
        );
      }

      const link = parsedHtml.createElement('a');
      const href = createHref(match);
      link.href = href;
      link.className = 'rich-text-link';
      setLinkAttributes(link);
      link.textContent = match;
      fragment.appendChild(link);

      lastIndex = offset + match.length;
      return match;
    });

    if (lastIndex < nodeValue.length) {
      fragment.appendChild(
        parsedHtml.createTextNode(nodeValue.slice(lastIndex)),
      );
    }

    textNode.parentNode?.replaceChild(fragment, textNode);
  });

  // Return full HTML content (not just one element)
  return parsedHtml.body.innerHTML;
};

export default addClassNameToRichText;
